// src/data/grammarQuestions/noticeAd3Questions.js
export const noticeAd3Questions = [
  {
    id: 1,
    koreanQuestion:
      "발표를 할 때 세미나에서, ______ 논의하는 것을 문제들을 그..  관련 없는 이 주제와.",
    question:
      "When making a presentation in the seminar, ______ discussing matters that are irrelevant to the topic.",
    choices: {
      A: "avoids",
      B: "avoiding",
      C: "to avoid",
      D: "avoid",
    },
    correctAnswer: "D",
    explanation: "'피하세요 논의하는 것을'이것이 화자의 목적이면 정답은 D가 된다.",
    translation:
      "세미나에서 발표를 할 때, 주제와 관련 없는 문제들을 논의하는 것을 피하세요.",
    type: "imperative",
  },
  {
    id: 2,
    koreanQuestion:
      "참석자들은 컨퍼런스 나가야 합니다 행사장을 즉시  그... 화재 경보가 울리는 경우에.",
    question:
      "Attendants of the conference should exit the venue immediately ______ that the fire alarm rings.",
    choices: {
      A: "despite",
      B: "in the event",
      C: "except",
      D: "because",
    },
    correctAnswer: "B",
    explanation:
      "A: '~에도 불구하고'라는 의미로, 이 문맥에서는 적절하지 않습니다. B: '~하는 경우에'라는 의미로, 화재 경보가 울리는 상황을 가정하므로 적절합니다. C: '~을 제외하고'라는 의미로, 이 문맥에서는 적절하지 않습니다. D: '~때문에'라는 의미로, 인과관계를 나타내지만 이 문맥에서는 조건을 나타내야 하므로 적절하지 않습니다.",
    translation:
      "컨퍼런스 참석자들은 화재 경보가 울리는 경우에 즉시 행사장을 나가야 합니다.",
    type: "conditional expressions",
  },
  {
    id: 3,
    koreanQuestion:
      "대학 학위 또는 ______ 요구됩니다 자격이 되기 위해 이 직책에",
    question:
      "A university degree or _____ is required to qualify for this position.",
    choices: {
      A: "high",
      B: "highest",
      C: "higher",
      D: "highly",
    },
    correctAnswer: "C",
    explanation:
      "A: 높은(형용사) B: 가장 높은(최상급 형용사) C: 더 높은(비교급 형용사) D: 매우, 대단히(부사) , high를 쓰려면 무엇이 높은지 뒤에 꼭 붙여줘야 해요.",
    translation:
      "이 직책에 지원하기 위해서는 대학 학위 또는 그 이상의 학력이 필요합니다.",
    type: "advertisement",
  },
  {
    id: 4,
    koreanQuestion:
      "성공적인 후보자는 또한 능숙할 것입니다 사용에 문서 편집 소프트웨어.",
    question:
      "The successful candidate will also be skilled ___ the use of document editing software.",
    choices: {
      A: "on",
      B: "at",
      C: "with",
      D: "in",
    },
    correctAnswer: "D",
    explanation:
      "A: ~위에(전치사) B: at도 가능하지만 동작/행동일때 더 자주 씀, ~에게(전치사) C: with는 도구와 같이 ~ 함께로 쓰임 D: ~안에, ~에서(전치사). 'skilled in'은 '~에 능숙한'이라는 의미.",
    translation:
      "성공적인 후보자는 문서 편집 소프트웨어 사용에 능숙할 것입니다.",
    type: "advertisement",
  },
  {
    id: 5,
    koreanQuestion:
      "참여하세요 우리의 로열티 프로그램에 그리고 되세요 자격이 큰 20% 할인 혜택을 위한.",
    question:
      "Take _____ in our loyalty program and become eligible for a whopping 20% discount.",
    choices: {
      A: "place",
      B: "part",
      C: "role",
      D: "share",
    },
    correctAnswer: "B",
    explanation: "'take part in'은 '~에 참여하다'라는 의미의 관용구입니다.",
    translation:
      "우리의 로열티 프로그램에 참여하시고 20%의 큰 할인 혜택을 받으세요.",
    type: "advertisement",
  },
  {
    id: 6,
    koreanQuestion:
      "우리 빌라는 자랑합니다 가장 ____ 주 내에서 , 빌라가 수용할 수 있어서 최대 60명을 하루에.",
    question:
      "Our villa stands out as the most _____ in the state, as it can accommodate as many as 60 people on any given day.",
    choices: {
      A: "spacious",
      B: "luxurious",
      C: "convenient",
      D: "reasonable",
    },
    correctAnswer: "A",
    explanation:
      "A: 넓은(형용사) B: 호화로운(형용사) C: 편리한(형용사) D: 합리적인(형용사). 60명을 수용할 수 있다는 맥락에서 '넓은(spacious)'이 가장 적절합니다.",
    translation:
      "우리 빌라는 하루에 최대 60명을 수용할 수 있어 주 내에서 가장 넓은 공간을 자랑합니다.",
    type: "advertisement",
  },
  {
    id: 7,
    koreanQuestion:
      "참고로 그... 우리의 주간 뉴스레터가 유지될 것이다 이용 가능하도록 ____ 고객들에게만 그... 구독한",
    question:
      "Note that our new weekly newsletter will remain available only to _____ customers who have subscribed.",
    choices: {
      A: "them",
      B: "these",
      C: "those",
      D: "their",
    },
    correctAnswer: "C",
    explanation:
      "A: '그들에게'라는 의미의 목적격 대명사로, 여기서는 적절하지 않습니다. B: '이러한'이라는 의미의 지시형용사로, 가까이 있는 것을 가리킬 때 사용합니다. C: '저러한'이라는 의미의 지시형용사로, 특정 그룹(여기서는 구독한 고객들)을 지칭할 때 적절합니다. D: '그들의'라는 의미의 소유격 대명사로, 여기서는 적절하지 않습니다.",
    translation:
      "참고로 우리의 새 주간 뉴스레터는 구독한 고객들에게만 계속 이용 가능할 것입니다.",
    type: "advertisement",
  },
  {
    id: 8,
    koreanQuestion:
      "당신이 _____한 후에 이메일 주소를 , 당신은 (미래에)리디렉션될 것입니다 페이지로 그... 당신이 지저앟ㄹ 수 있는 당신의 선호하는 주제들과 헤드라인을.",
    question:
      "After you _____ your email address, you'll be redirected to a page where you'll be able to specify your preferred topics and headlines.",
    choices: {
      A: "confirmation",
      B: "confirm",
      C: "confirmed",
      D: "confirming",
    },
    correctAnswer: "B",
    explanation:
      "A: '확인'이라는 의미의 명사로, 동사가 필요한 이 문맥에서는 적절하지 않습니다. B: '확인하다'라는 의미의 동사 원형으로, 시간 접속사 'After' 뒤에 현재형을 사용하여 미래에 일어날 일을 나타내는 것이 적절합니다. 'you'll be redirected'(미래형)와 시제가 일치합니다. C: '확인했다'라는 의미의 과거형 동사로, 미래 상황을 설명하는 이 문맥에서는 시제 불일치가 발생합니다. D: '확인하는 중'이라는 의미의 현재분사로, 이 문맥에서는 적절하지 않습니다.",
    translation:
      "이메일 주소를 확인한 후에, 당신은 선호하는 주제와 헤드라인을 지정할 수 있는 페이지로 리디렉션될 것입니다.",
    type: "advertisement",
  },
  {
    id: 9,
    koreanQuestion:
      "당신이 (현재) 이미 구독하지 않았다면 그렇게, 당신은 구독할 수 있습니다 우리의 새로운 주간 뉴스레터를 www.lunariastyle.com에서.",
    question:
      "_____ you have already done so, you can subscribe to our new weekly newsletter at www.lunariastyle.com.",
    choices: {
      A: "If",
      B: "Although",
      C: "Unless",
      D: "Since",
    },
    correctAnswer: "C",
    explanation:
      "A: '만약 ~라면'이라는 의미의 조건절 접속사로, 이미 구독한 경우에도 다시 구독할 수 있다는 의미가 되어 문맥상 맞지 않습니다. B: '비록 ~일지라도'라는 의미의 양보절 접속사로, 문맥상 적절하지 않습니다. C: '~하지 않는 한'이라는 의미의 조건절 접속사로, '이미 구독하지 않았다면 구독할 수 있다'는 의미를 전달하여 가장 적절합니다. D: '~이후로'라는 의미의 시간/이유 접속사로, 문맥상 적절하지 않습니다.",
    translation:
      "이미 구독하지 않았다면, 당신은 www.lunariastyle.com에서 우리의 새로운 주간 뉴스레터를 구독할 수 있습니다.",
    type: "advertisement",
  },
  {
    id: 10,
    koreanQuestion:
      "참고하세요 그... 다수의 장학금 뿐만아니라 연구 보조금이 가능합니다 시에라 국제 법률 아카데미에서 국내 및 국제 학생들 모두에게.",
    question:
      "Please note that a number of scholarships as well as research grants _____ available at Sierra International Law Academy to local and international students alike.",
    choices: {
      A: "is",
      B: "are",
      C: "was",
      D: "has been",
    },
    correctAnswer: "B",
    explanation:
      "복수주어(a number of scholarships as well as research grants)에 맞는 동사는 B입니다.",
    translation:
      "다수의 장학금과 연구 보조금이 시에라 국제 법률 아카데미에서 국내 및 국제 학생들 모두에게 제공됨을 참고하시기 바랍니다.",
    type: "advertisement",
  },
  {
    id: 11,
    koreanQuestion:
      "또한, 고등 교육 학위는 경영학 분야의 ________ , 그리고 탁월한 의사소통 능력은 확실히 장점입니다.",
    question:
      "In addition, a higher education degree in business administration is a _____, and excellent communication skills are certainly a plus.",
    choices: {
      A: "must",
      B: "should",
      C: "have",
      D: "standard",
    },
    correctAnswer: "A",
    explanation:
      "A: '필수'라는 의미의 명사로, 'is a must'는 '필수이다'라는 표현으로 문맥에 가장 적합합니다.",
    translation:
      "또한, 경영학 분야의 고등 교육 학위는 필수이며, 탁월한 의사소통 능력은 확실히 장점입니다.",
    type: "advertisement",
  },
  {
    id: 12,
    koreanQuestion:
      "우선권이 주어질 것이다 특정 지원자들에게 그... 받은 직업훈련을 수리와 유지보수에 대한 상업용 트럭.",
    question:
      "Preference will be given to those candidates _____ have received vocational training in the repair and maintenance of commercial trucks.",
    choices: {
      A: "who",
      B: "which",
      C: "where",
      D: "what",
    },
    correctAnswer: "A",
    explanation:
      "A: '누구'라는 의미의 관계대명사로, 사람(candidates)을 선행사로 받아 적절합니다. B: '어떤 것'이라는 의미의 관계대명사로, 사물을 선행사로 받기 때문에 부적절합니다. C: '어디에'라는 의미의 관계부사로, 장소를 나타내는 선행사에 사용되므로 부적절합니다. D: '무엇'이라는 의미의 관계대명사로, 이 문맥에서는 부적절합니다.",
    translation:
      "상업용 트럭의 수리 및 유지보수에 대한 직업 훈련을 받은 지원자들에게 우선권이 주어질 것입니다.",
    type: "advertisement",
  },
];
